
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2bb7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2bb7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3JaYo", function(module, exports) {

$parcel$export(module.exports, "fetchManifestFromUrl", () => $2b6e161c9edcf319$export$276b436c08e5f971);

var $5N2AT = parcelRequire("5N2AT");
/*
    returns an object satisfying the IManifestOptions inteface
    It is declared as a function with plan that in future development
    it will be populated based in user input elements
*/ function $2b6e161c9edcf319$var$getRequestedManifestOptions() {
    var retVal = {
        'locale': "en"
    };
    return retVal;
}
async function $2b6e161c9edcf319$export$276b436c08e5f971(manifestUrl) {
    var urlObj = new URL(manifestUrl);
    console.log('parsed manifestUrl protocol ', urlObj.protocol);
    var manifestText;
    if (urlObj.protocol == "data:") {
        console.log("handle data url");
        manifestText = $2b6e161c9edcf319$var$parseDataUri(manifestUrl);
    } else {
        var response = await fetch(encodeURI(manifestUrl));
        if (response.ok) manifestText = await response.text();
        else throw new Error("network fetch of manifest failed");
    }
    console.log("json result ", manifestText);
    var manifestObj = JSON.parse(manifestText);
    var options = $2b6e161c9edcf319$var$getRequestedManifestOptions();
    var retVal = new $5N2AT.Manifest(manifestObj, options);
    console.log("manifest parsed into Manifesto object");
    // prepare the pretty text
    // reference https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify
    //var prettyText = JSON.stringify( manifestObj, undefined, 2);
    //document.querySelector("textarea#manifest-text").value = prettyText;
    return retVal;
}
function $2b6e161c9edcf319$var$parseDataUri(dataUri) {
    const ix = dataUri.indexOf(",");
    if (ix >= 0) // TODO: insert identification of Mimetype , base64
    return decodeURIComponent(dataUri.substring(ix + 1));
}

});


parcelRequire("3JaYo");

//# sourceMappingURL=iiif-x3dom-demo.8bf44e07.js.map
